import 'whatwg-fetch'
import React from 'react'
import ReactDOM from 'react-dom'
// POLYFILL
import 'polyfill-array-includes'

import App from './App'

import './styles/fonts'
import './styles/global'
// import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(<App />, document.getElementById('app'))
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js